export const baseUrl = '/invoices'
